/**
 * How to combine result of all condition satisfy
 */
export enum ConditionCombinationType{
    All = "All",
    Any = "Any"
}